module.exports = __webpack_public_path__ + "static/media/22792147_1629540643787787_3674829621216631327_o.1ee88076.jpg";